import {
    apiRequest,
    // acmanajerialLevel,
    dokumenpelantikanDetail
} from "../../../../../services/adapters/kepegawaian/dokumenPelantikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", dokumenpelantikanDetail, {
            params: query
        }, true)
    }

    // fetchLevel = async (query) => {
    //     return await apiRequest("get", acmanajerialLevel, {
    //         params: query
    //     }, true)
    // }
}

export default DetailRepository